module.exports = __webpack_public_path__ + "img/initial1893.4f01ccb3.png";